module.exports = __webpack_public_path__ + "img/Trash.32897e0b.svg";